module.exports = __webpack_public_path__ + "img/share.84b318f4.svg";